import { render } from "./RecBosang.vue?vue&type=template&id=9e4f7d44"
import script from "./RecBosang.vue?vue&type=script&lang=js"
export * from "./RecBosang.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__